
const ButtonAnchor = ({ className = "", to, text, icon_path, alt_text, target="_blank" }) => {

  const scrollToTop = () => {
    if (to != "#my-projects") {
      window.scrollTo(0, 0)
    } else {
      const heroImageHeight = document.querySelector(".hero").offsetHeight;
      window.scrollTo(0, heroImageHeight);
    }
    
  }

  return (
    <a className={className} onClick={scrollToTop} href={ to != "#my-projects" && to } target={ target }>
      <div className="button">
        <h6>{ text }</h6>
        <img className="icon" src={ icon_path } alt={ alt_text } />
      </div>
    </a>
      
  );
}

export default ButtonAnchor;